import React from "react";
import Card from "./Card";

/**
 * Phase 2 — EmptyState
 *
 * Consistent empty-state for any list/search page.
 *
 *   <EmptyState
 *     icon={<Inbox size={36} />}
 *     title="Nothing to review"
 *     description="When employees submit new product requests, they'll show up here."
 *     action={<Button tier="primary">Refresh</Button>}
 *   />
 */
export default function EmptyState({
  icon,
  title,
  description,
  action,
  className = "",
  "data-testid": testId = "empty-state",
}) {
  return (
    <Card
      variant="raised"
      className={`p-10 flex flex-col items-center text-center ${className}`}
      data-testid={testId}
    >
      {icon && (
        <div className="text-ink-3 mb-4">{icon}</div>
      )}
      {title && (
        <h3 className="font-display font-bold text-lg text-ink mb-2">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-sm text-ink-2 max-w-md mb-4 leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </Card>
  );
}
